import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProviderComponent } from './provider/provider.component';
import { TestConnectionComponent } from './test-connection/test-connection.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [
    ProviderComponent,
    TestConnectionComponent
  ],
  imports: [
    CommonModule,
    SharedModule.forRoot()
  ]
})
export class ProviderModule { }
